import { useEffect } from "react";
import { useHive } from "@/store/useHive";

/** Keeps the Activity Center fresh by polling the org's real audit activity. */
export function useLiveActivity() {
  const refreshActivity = useHive((s) => s.refreshActivity);
  useEffect(() => {
    const id = setInterval(() => void refreshActivity(), 30_000);
    return () => clearInterval(id);
  }, [refreshActivity]);
}
